import { AgreementStatus } from "@debitroom-software/types";
import { NavigationGuardNext, RouteLocationNormalized } from "vue-router";

import { useAuthorisationStore } from "@/modules/authorisation/authorisationStore";

export default async function checkPartnerAgreementStatus(
  to: RouteLocationNormalized,
  from: RouteLocationNormalized,
  next: NavigationGuardNext
) {
  const authorisationStore = useAuthorisationStore();
  await authorisationStore.fetchProfileInformation();
  if (authorisationStore.hasErrorBecauseOfNoPartnerAccount) {
    return next({ name: "403" });
  }
  if (authorisationStore.agreements?.funderAgreementStatus !== AgreementStatus.Signed) {
    return next({ name: "funders.noAgreement" });
  }
  next();
}
